export const OFFER_TYPE_SITE_WIDE_AMOUNT = 'sitewide amount'
export const OFFER_TYPE_SITE_WIDE_PERCENT = 'sitewide percent'
export const OFFER_TYPE_FREE_SHIPPING = 'free shipping'
export const OFFER_TYPE_SALE_AMOUNT = 'sale amount'
export const OFFER_TYPE_SALE_PERCENT = 'sale percent'
export const OFFER_TYPE_FREE_PRODUCT = 'Free Product'
export const OFFER_TYPE_OTHER = 'Other'

export const offerTypes = [
  OFFER_TYPE_SITE_WIDE_AMOUNT,
  OFFER_TYPE_SITE_WIDE_PERCENT,
  OFFER_TYPE_FREE_SHIPPING,
  OFFER_TYPE_SALE_AMOUNT,
  OFFER_TYPE_SALE_PERCENT,
  OFFER_TYPE_FREE_PRODUCT,
  OFFER_TYPE_OTHER,
]
